// STORE DEPENDANCY
import { Action } from '@ngrx/store';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';

export enum ActionTypes {
  // USER ACTIONS
  USER_COMMON = '[USER] USER Common',
  USER_COMMON_SUCCESS = '[USER] USER Common Success',
}

// -------------------------------
//  User Common
// -------------------------------
export class UserCommonAction implements Action {
  readonly type = ActionTypes.USER_COMMON;
  constructor(public payload: ApiPayload) { }
}

// -------------------------------
//  User Common Success
// -------------------------------
export class UserCommonSuccessAction implements Action {
  readonly type = ActionTypes.USER_COMMON_SUCCESS;
  constructor(public response?: any) { }
}

export type Actions =
  | UserCommonAction
  | UserCommonSuccessAction;
